import React, { useMemo, useState } from 'react';
import { useTranslations } from 'use-intl';

interface RefinementListProps {
  name: string;
  value: string[];
  options: { value: string; count: number }[];
  onFilter: (key: string, value: string) => void;
}

export const RefinementList = ({
  name,
  value: currentValue,
  options,
  onFilter,
}: RefinementListProps) => {
  const t = useTranslations('Swap.Filters');
  const [search, setSearch] = useState('');

  const filteredItems = useMemo(() => {
    if (search) {
      return options.filter(({ value }) =>
        value.toLowerCase().includes(search.toLowerCase())
      );
    } else {
      return options;
    }
  }, [search, options]);

  return (
    <ul className={`space-y-2 text-left`}>
      <li>
        <input
          type="search"
          value={search}
          onChange={(event) => setSearch(event.currentTarget.value)}
          className="text-sm mb-2 w-full bg-white p-2 sm:p-2.5 rounded-md border border-gray-200 placeholder:text-gray-400 placeholder:focus:text-gray-400 focus:outline-none focus:ring-0 focus:border-gray-400/75"
          placeholder={t('filter', { attribute: name })}
        />
      </li>
      {filteredItems.map(({ count, value }) => (
        <li key={value}>
          <label className="flex w-full justify-between cursor-pointer items-center text-sm">
            <input
              type="checkbox"
              onChange={() => {
                onFilter(name, value);
              }}
              className={`rounded-[4px] mr-2 text-pink-500 border-pink-500 focus:ring-pink-600 cursor-pointer`}
              checked={currentValue.includes(value)}
            />
            <span>{value}</span>
            <span className="flex-1 w-full justify-between flex">
              <span className="ml-2">({count})</span>
            </span>
          </label>
        </li>
      ))}
    </ul>
  );
};

export default RefinementList;
